import { faCircleXmark } from '@fortawesome/free-solid-svg-icons'
import type { FC } from 'react'
import React from 'react'
import styled from 'styled-components'

import ActionButton from '@/components/ActionButton'

interface Props {
  onClick: () => void
  disabled?: boolean
}

const Container = styled.div`
  width: 120px;
`

const UnableToVerifyButton: FC<Props> = ({ onClick, disabled = false }) => (
  <Container>
    <ActionButton
      label="Unable to verify"
      icon={faCircleXmark}
      onClick={onClick}
      disabled={disabled}
    />
  </Container>
)

export default UnableToVerifyButton
